import { faqs } from '@/mocks/communityData';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsTopics from './components/StatsTopics';
import Categories from './components/Categories';
import Highlights from './components/Highlights';
import Community from './components/Community';
import Guide from './components/Guide';
import Faq from './components/Faq';
import Join from './components/Join';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50 text-foreground-900">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main className="flex-1">
        <Hero />
        <StatsTopics />
        <Categories />
        <Highlights />
        <Community />
        <Guide />
        <Faq />
        <Join />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}